import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import moment from "moment";
import CampaignSendScheduleForm from "./CampaignSendScheduleForm";
import CampaignSendBehaviorDomainService from "../../../Domain/CampaignSendBehavior/CampaignSendBehavior.service";
import CampaignService from "../../../Services/Campaign.service";
import AutomatedScheduleDomainService from "../../../Domain/AutomatedSchedule/AutomatedSchedule.service";
import DateService from "../../../Services/Shared/Date.service";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
// used to fill out the modal form
const campaignToAutomatedScheduleState = (campaign) => {
    var _a, _b;
    return {
        sendBehavior: campaign.sendBehavior.id ===
            CampaignSendBehaviorDomainService.SendOnStart.id
            ? "manual"
            : "scheduled",
        isOngoing: campaign.sendBehavior.id ===
            CampaignSendBehaviorDomainService.SendOngoing.id,
        sendDateTime: (_a = campaign.automatedSchedule) === null || _a === void 0 ? void 0 : _a.startDate,
        sendDate: ((_b = campaign.automatedSchedule) === null || _b === void 0 ? void 0 : _b.startDate)
            ? moment(campaign.automatedSchedule.startDate)
            : null,
        automatedSchedule: campaign === null || campaign === void 0 ? void 0 : campaign.automatedSchedule,
    };
};
const CampaignSendScheduleModal = ({ isOpen, onSuccess, close, campaign, }) => {
    const updatedCampaignScheduleToCampaignRequest = (updatedCampaign) => {
        const sendDate = updatedCampaign.sendDate
            ? DateService.getDateWithTime(updatedCampaign.sendDate.toDate(), updatedCampaign.sendDateTime)
            : null;
        let sendBehavior = CampaignSendBehaviorDomainService.SendOnDate.id;
        if (updatedCampaign.sendBehavior === "scheduled") {
            sendBehavior = updatedCampaign.isOngoing
                ? CampaignSendBehaviorDomainService.SendOngoing.id
                : CampaignSendBehaviorDomainService.SendOnDate.id;
        }
        let fullAutomatedSchedule = null;
        let automatedSchedule = null;
        if (sendBehavior === CampaignSendBehaviorDomainService.SendOngoing.id) {
            fullAutomatedSchedule = updatedCampaign.automatedSchedule;
            if (!fullAutomatedSchedule ||
                fullAutomatedSchedule.scheduleType ===
                    AutomatedScheduleDomainService.ScheduleType.RRuleAutomatedSchedule) {
                automatedSchedule = {
                    scheduleType: fullAutomatedSchedule === null || fullAutomatedSchedule === void 0 ? void 0 : fullAutomatedSchedule.scheduleType,
                    rrule: fullAutomatedSchedule === null || fullAutomatedSchedule === void 0 ? void 0 : fullAutomatedSchedule.rrule,
                    startDate: fullAutomatedSchedule === null || fullAutomatedSchedule === void 0 ? void 0 : fullAutomatedSchedule.startDate,
                };
            }
        }
        return {
            sendDate,
            automatedSchedule,
            sendBehavior,
            id: campaign.id,
        };
    };
    return (_jsx(ModalFormFormat, { defaultValue: campaignToAutomatedScheduleState(campaign), handleSubmit: (formState) => CampaignService.editAutomatedSchedule(updatedCampaignScheduleToCampaignRequest(formState)), onModalClosed: () => close(), size: "lg", modalTitle: "Edit Schedule", errorMessage: "There was an error editing this schedule", saveButtonContents: "Save", isOpen: isOpen, onSuccess: onSuccess, children: _jsx(CampaignSendScheduleForm, { isEditing: true }) }));
};
export default CampaignSendScheduleModal;
